{
	"title": "Assure carbon reductions",
	"plantLabel": "Location"
}
